import { FormatNumber2 } from '../tools';

const readAmount = (value) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }

  return (
    Number(String(value || '').replace(/,/g, '').replace(/Dr|Cr/gi, '').trim()) ||
    0
  );
};

const readType = (row, amountField, typeField) => {
  const type = String(row[typeField] || row[amountField] || '').toUpperCase();
  return type.includes('CR') ? 'cr' : 'dr';
};

const BalanceAmounts = ({ amounts }) => (
  <div className="w-full text-right text-[10px] font-semibold leading-4">
    {amounts.dr ? (
      <div>
        <span className="mr-1 text-[8px] font-bold text-gray-500">DR</span>
        {FormatNumber2(amounts.dr)}
      </div>
    ) : null}
    {amounts.cr ? (
      <div>
        <span className="mr-1 text-[8px] font-bold text-gray-500">CR</span>
        {FormatNumber2(amounts.cr)}
      </div>
    ) : null}
    {!amounts.dr && !amounts.cr ? '-' : null}
  </div>
);

export const PartyLedgerFooter = ({ rows, columns, insideTable = false }) => {
  const totals = rows.reduce(
    (result, row) => {
      const openingType = readType(
        row,
        'OPENING_BALANCE',
        'OPENING_BAL_TYPE'
      );
      const closingType = readType(
        row,
        'CLOSING_BALANCE',
        'CLOSING_BAL_TYPE'
      );
      const closingWithoutOpeningType = readType(
        row,
        'CLOSING_WITHOUT_OPENING',
        'CLOSING_WITHOUT_OPENING_TYPE'
      );

      result.opening[openingType] += readAmount(row.OPENING_BALANCE);
      result.debit += readAmount(row.OPENING_DEBIT || row.DEBIT);
      result.credit += readAmount(row.OPENING_CREDIT || row.CREDIT);
      result.closing[closingType] += readAmount(row.CLOSING_BALANCE);
      result.closingWithoutOpening[closingWithoutOpeningType] += readAmount(
        row.CLOSING_WITHOUT_OPENING
      );
      return result;
    },
    {
      opening: { dr: 0, cr: 0 },
      debit: 0,
      credit: 0,
      closing: { dr: 0, cr: 0 },
      closingWithoutOpening: { dr: 0, cr: 0 },
    }
  );

  const renderTotal = (field) => {
    if (field === 'NAME') {
      return (
        <div className="text-left leading-4">
          <div className="font-bold">GRAND TOTAL</div>
          <div className="text-[9px] font-normal text-gray-600">
            {rows.length} parties
          </div>
        </div>
      );
    }
    if (field === 'OPENING_BALANCE') {
      return <BalanceAmounts amounts={totals.opening} />;
    }
    if (field === 'OPENING_DEBIT') {
      return totals.debit ? FormatNumber2(totals.debit) : '-';
    }
    if (field === 'OPENING_CREDIT') {
      return totals.credit ? FormatNumber2(totals.credit) : '-';
    }
    if (field === 'CLOSING_BALANCE') {
      return <BalanceAmounts amounts={totals.closing} />;
    }
    if (field === 'CLOSING_WITHOUT_OPENING') {
      return <BalanceAmounts amounts={totals.closingWithoutOpening} />;
    }
    return null;
  };

  const footer = (
    <tfoot className="text-[10px] text-black">
        <tr className="bg-gray-200">
          {columns.map((column) => (
            <td
              key={column.field}
              style={{
                padding: '8px',
                borderRight: '1px solid #6b7280',
                borderTop: '2px solid #4b5563',
                borderBottom: '1px solid #6b7280',
                textAlign: column.field === 'NAME' ? 'left' : 'right',
                verticalAlign: 'middle',
                backgroundColor:
                  column.field === 'CLOSING_WITHOUT_OPENING'
                    ? '#e0f2fe'
                    : '#e5e7eb',
              }}
              className={`text-right align-middle ${
                column.field === 'CLOSING_WITHOUT_OPENING' ? 'bg-sky-100' : ''
              }`}
            >
              {renderTotal(column.field)}
            </td>
          ))}
        </tr>
    </tfoot>
  );

  if (insideTable) {
    return footer;
  }

  return (
    <table className="w-full table-fixed border-collapse">
      <colgroup>
        {columns.map((column) => (
          <col
            key={column.field}
            style={column.width ? { width: column.width } : undefined}
          />
        ))}
      </colgroup>
      {footer}
    </table>
  );
};
